module.exports = __webpack_public_path__ + "static/media/header-home-background.215163d3.jpg";